import { Select } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const FREQUENCIA = {
  DIARIO: { id: "DIARIO", label: "Diário" },
  SEMANAL: { id: "SEMANAL", label: "Semanal" },
  MENSAL: { id: "MENSAL", label: "Mensal" },
};

export default function SelectTipoFrequencia(props) {
  const { t } = useTranslation();

  const createOption = ({ id, label }) => (
    <Select.Option key={id} value={id}>
      {t(label)}
    </Select.Option>
  );

  return (
    <Select {...props}>
      {createOption(FREQUENCIA.DIARIO)}
      {createOption(FREQUENCIA.SEMANAL)}
      {createOption(FREQUENCIA.MENSAL)}
    </Select>
  );
}

SelectTipoFrequencia.propTypes = {
  value: PropTypes.oneOf([
    FREQUENCIA.DIARIO.id,
    FREQUENCIA.SEMANAL.id,
    FREQUENCIA.MENSAL.id,
  ]),
  onChange: PropTypes.func,
};
